import script from "./h-menu-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./h-menu-item.vue?vue&type=script&lang=ts&setup=true"

import "./h-menu-item.vue?vue&type=style&index=0&id=16c04f49&lang=scss"

const __exports__ = script;

export default __exports__